import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

type LogClickFolderParams = {
  folderSno: number;
};

export const useLogClickFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ folderSno }: LogClickFolderParams) => {
      logAnalyticsEvent({
        name: 'CLICK_FOLDER',
        analytics: {
          FOLDER_SNO: folderSno.toString(),
          TAB: 'FOLDER',
          LANDING_FROM: 'FOLDER',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
